import { useProposalT } from "../i18n/ProposalI18nContext";

const CONSULTANT_PHOTO =
  "https://d1y4va1nna2r1p.cloudfront.net/spaces/f11030d7-4125-45b8-96de-65f0a02271ce.png";

const WHATSAPP_CONSULTANT_URL =
  "https://wa.me/5511936203719?text=Ol%C3%A1%20Bruna%2C%20vi%20a%20proposta%20da%20Woba";

export function NextStepsSection({
  showScheduling = true,
  visitSelectedIds,
  onSchedule,
}: {
  showScheduling?: boolean;
  visitSelectedIds?: Set<string>;
  onSchedule?: () => void;
}) {
  const { t } = useProposalT();

  const nextSteps = [
    {
      num: "01",
      title: t("nextSteps.step1.title"),
      desc: t("nextSteps.step1.desc"),
      timing: t("nextSteps.step1.timing"),
    },
    {
      num: "02",
      title: t("nextSteps.step2.title"),
      desc: t("nextSteps.step2.desc"),
      timing: t("nextSteps.step2.timing"),
    },
    {
      num: "03",
      title: t("nextSteps.step3.title"),
      desc: t("nextSteps.step3.desc"),
      timing: t("nextSteps.step3.timing"),
    },
  ];

  const handleCTAClick = (e: React.MouseEvent) => {
    e.preventDefault();
    const count = visitSelectedIds?.size ?? 0;
    if (count > 0 && onSchedule) {
      onSchedule();
    } else {
      document
        .getElementById("comparativo")
        ?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      className="py-16 px-6"
      style={{ background: "#FDFBF7", borderTop: "1px solid #E8E6E3" }}
    >
      <div style={{ maxWidth: "1000px", margin: "0 auto" }}>
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: "48px" }}>
          <h2
            style={{
              fontFamily: "'Space Grotesk', sans-serif",
              fontSize: "32px",
              fontWeight: 700,
              color: "#1A1814",
              margin: "0 0 10px",
            }}
          >
            {t("nextSteps.heading")}
          </h2>
          <p style={{ fontSize: "16px", color: "#78736D", margin: 0 }}>
            {t("nextSteps.subheading")}
          </p>
        </div>

        {/* Timeline — horizontal on md+, vertical on mobile */}
        {/* Desktop: horizontal */}
        <div className="hidden md:flex relative mb-12">
          <div
            style={{
              position: "absolute",
              top: "28px",
              left: "56px",
              right: "56px",
              height: "2px",
              background: "#E8E6E3",
              zIndex: 0,
            }}
          />
          {nextSteps.map((step) => (
            <div
              key={step.num}
              style={{
                flex: 1,
                textAlign: "center",
                position: "relative",
                zIndex: 1,
              }}
            >
              <div
                style={{
                  width: "56px",
                  height: "56px",
                  borderRadius: "50%",
                  background: "#FFD900",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 16px",
                  boxShadow: "0 2px 8px rgba(255,217,0,0.3)",
                }}
              >
                <span
                  style={{
                    fontSize: "18px",
                    fontWeight: 800,
                    color: "#1A1814",
                  }}
                >
                  {step.num}
                </span>
              </div>
              <p
                style={{
                  fontSize: "15px",
                  fontWeight: 700,
                  color: "#1A1814",
                  margin: "0 0 4px",
                }}
              >
                {step.title}
              </p>
              <p
                style={{
                  fontSize: "13px",
                  color: "#78736D",
                  margin: "0 0 8px",
                }}
              >
                {step.desc}
              </p>
              <span
                style={{
                  display: "inline-block",
                  padding: "3px 12px",
                  borderRadius: "999px",
                  fontSize: "11px",
                  fontWeight: 600,
                  background: "#FFF8E1",
                  color: "#B8860B",
                }}
              >
                {step.timing}
              </span>
            </div>
          ))}
        </div>

        {/* Mobile: vertical */}
        <div className="md:hidden flex flex-col gap-0 mb-10 relative">
          <div
            style={{
              position: "absolute",
              top: "28px",
              bottom: "28px",
              left: "27px",
              width: "2px",
              background: "#E8E6E3",
              zIndex: 0,
            }}
          />
          {nextSteps.map((step) => (
            <div
              key={step.num}
              className="flex items-start gap-4 relative z-[1] pb-6 last:pb-0"
            >
              <div
                style={{
                  width: "56px",
                  height: "56px",
                  borderRadius: "50%",
                  background: "#FFD900",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  boxShadow: "0 2px 8px rgba(255,217,0,0.3)",
                }}
              >
                <span
                  style={{
                    fontSize: "16px",
                    fontWeight: 800,
                    color: "#1A1814",
                  }}
                >
                  {step.num}
                </span>
              </div>
              <div className="pt-3">
                <p
                  style={{
                    fontSize: "15px",
                    fontWeight: 700,
                    color: "#1A1814",
                    margin: "0 0 2px",
                  }}
                >
                  {step.title}
                </p>
                <p
                  style={{
                    fontSize: "13px",
                    color: "#78736D",
                    margin: "0 0 6px",
                  }}
                >
                  {step.desc}
                </p>
                <span
                  style={{
                    display: "inline-block",
                    padding: "3px 12px",
                    borderRadius: "999px",
                    fontSize: "11px",
                    fontWeight: 600,
                    background: "#FFF8E1",
                    color: "#B8860B",
                  }}
                >
                  {step.timing}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        {showScheduling && (
          <div className="mb-10 px-0 md:px-6 text-center">
            <a
              href="#comparativo"
              onClick={handleCTAClick}
              className="w-full md:w-auto inline-flex items-center justify-center gap-2.5 rounded-2xl font-bold transition-all duration-200"
              style={{
                padding: "16px 40px",
                background: "#FFD900",
                color: "#1A1814",
                fontFamily: "'Space Grotesk', sans-serif",
                fontSize: "16px",
                textDecoration: "none",
                boxShadow: "0 4px 20px rgba(255,217,0,0.35)",
              }}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                <line x1="16" y1="2" x2="16" y2="6" />
                <line x1="8" y1="2" x2="8" y2="6" />
                <line x1="3" y1="10" x2="21" y2="10" />
              </svg>
              {t("nextSteps.scheduleVisits")}
            </a>
            <p
              style={{ fontSize: "13px", color: "#9E9A94", margin: "12px 0 0" }}
            >
              {t("nextSteps.seeSpaces")}
            </p>
          </div>
        )}

        {/* Bruna / consultant card */}
        {showScheduling && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <img
              src={CONSULTANT_PHOTO}
              alt="Bruna"
              style={{
                width: "64px",
                height: "64px",
                borderRadius: "50%",
                objectFit: "cover",
                border: "3px solid #FFD900",
              }}
            />
            <div style={{ textAlign: "center" }}>
              <p
                style={{
                  fontSize: "13px",
                  color: "#78736D",
                  margin: "0 0 4px",
                }}
              >
                {t("nextSteps.consultantQuestion")}
              </p>
              <div className="flex flex-wrap items-center justify-center gap-2">
                <span
                  style={{
                    fontFamily: "'Space Grotesk', sans-serif",
                    fontSize: "14px",
                    fontWeight: 700,
                    color: "#1A1814",
                  }}
                >
                  Bruna
                </span>
                <span style={{ fontSize: "12px", color: "#78736D" }}>
                  {t("nextSteps.consultantRole")}
                </span>
                <a
                  href={WHATSAPP_CONSULTANT_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "4px",
                    padding: "5px 12px",
                    borderRadius: "8px",
                    background: "#25D366",
                    color: "white",
                    fontSize: "12px",
                    fontWeight: 600,
                    textDecoration: "none",
                  }}
                >
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
                    <path d="M12 0C5.373 0 0 5.373 0 12c0 2.625.846 5.059 2.284 7.034L.789 23.492a.5.5 0 00.611.611l4.458-1.495A11.943 11.943 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-2.352 0-4.55-.653-6.433-1.785l-.448-.267-2.648.887.888-2.648-.267-.448A9.953 9.953 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z" />
                  </svg>
                  WhatsApp
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
